import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    boxSizing: 'border-box',
  },
  tableContainer: {
    height: "calc(100% - 40px)",
    width: "100%",
  },
  iconContainer: {
    display: "inline-block",
    cursor: "pointer",
  },
}));